import React from "react";
import { motion } from "framer-motion";
import Header from "./customer/Header";
import HomeHeader from "./customer/HomeHeader";
import AppFooter from "./customer/AppFooter";

const PrivacyPolicy = () => {
  const access = localStorage.getItem("accessToken");

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <header>
        {access ? <Header /> : <HomeHeader />}
      </header>

      {/* Animated Content with shadow container */}
      <motion.main
        className="flex-grow px-4 py-8 max-w-4xl mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="bg-white shadow-xl rounded-2xl p-6 text-justify">
          <h1 className="text-2xl font-bold mb-6 text-center text-[#9061DB]">
            Privacy Policy
          </h1>

          <p className="mb-4">
            At <strong>Onzitr</strong>, we are committed to safeguarding your privacy. This
            Privacy Policy explains how we collect, use, and protect your
            personal information when you use our website. By using our
            website, you consent to the practices described below.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            1. Information We Collect
          </h2>
          <p className="mb-4">
            We may collect the following types of information when you use our
            website:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>
              <strong>Personal Information:</strong> such as your name, contact
              details, and any other information you voluntarily provide.
            </li>
            <li>
              <strong>Usage Data:</strong> details about how you interact with
              our website, including pages visited and actions taken.
            </li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            2. How We Use Your Information
          </h2>
          <p className="mb-4">We use your information for purposes including:</p>
          <ul className="list-disc list-inside mb-4">
            <li>Improving our website’s content and functionality.</li>
            <li>Personalizing your experience and providing relevant content.</li>
            <li>Communicating with you about our services, offers, and updates.</li>
            <li>Analyzing user behavior and trends to enhance our services.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            3. Information Security
          </h2>
          <p className="mb-4">
            We take industry-standard measures to protect your information
            against unauthorized access, alteration, or disclosure.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            4. Cookies and Tracking
          </h2>
          <p className="mb-4">
            Our website may use cookies and similar technologies to improve user
            experience. You can adjust your browser settings to manage or delete
            cookies.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            5. Third-Party Links
          </h2>
          <p className="mb-4">
            Our website may include links to third-party websites. We are not
            responsible for the privacy practices or content of these websites.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            6. Your Choices
          </h2>
          <p className="mb-4">
            You can opt out of receiving promotional communications from us by
            following the unsubscribe instructions in our emails. You may also
            contact us to update or correct your personal information.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            7. Children’s Privacy
          </h2>
          <p className="mb-4">
            We do not knowingly collect personal information from children under
            13, nor do we target our services to them.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            8. Changes to this Policy
          </h2>
          <p className="mb-4">
            We may update this Privacy Policy to reflect changes in our
            practices or legal requirements. Any updates will be posted on this
            page.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            9. Contact Us
          </h2>
          <p className="mb-4">
            If you have questions or concerns about this Privacy Policy, please
            email us at
            <a
              href="mailto:info@gksinfotech.in"
              className="text-[#9061DB] underline ml-1"
            >
              info@gksinfotech.in
            </a>
            .
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-2 text-[#9061DB]">
            10. Consent
          </h2>
          <p className="mb-4">
            By using our website, you acknowledge that you have read,
            understood, and agree to this Privacy Policy and its terms.
          </p>
        </div>
      </motion.main>

      {/* Footer */}
      <footer>
        <AppFooter />
      </footer>
    </div>
    
  );
};

export default PrivacyPolicy;
